import React from "react";
import { Separator, Spinner } from "@lemonadetraining/web-ui";
import MyCard from "./MyCard";

const WidgetCard = (props) => {
  return (
    <MyCard>
      <div>
        <div className="flex flex-row justify-between items-center gap-6">
          <div className="flex-1">
            {typeof props.title === "string" ? (
              <h3 className="text-base font-semibold">{props.title}</h3>
            ) : (
              props.title
            )}
          </div>
          {props.isLoading && <Spinner className="h-5 w-5" />}
        </div>
        {props.subTitle && <p className="text-sm text-muted-foreground">{props.subTitle}</p>}
      </div>
      <Separator />
      {props.children}
    </MyCard>
  );
};

export default WidgetCard;
